import React from 'react';
import PropTypes from 'prop-types';

/**
 * Passthrough stub retained for Security MFE compatibility after Tealium retirement.
 * Renders children without data-wat-* attributes; static methods are no-ops.
 */
const TealiumTags = ({ children }) => {
  if (React.Children.count(children) > 1) {
    return <span>{children}</span>;
  }
  return children;
};

TealiumTags.addEvent = () => {};

TealiumTags.addLinkClickEvent = () => {};

TealiumTags.addContentViewedEvent = () => {};

TealiumTags.formatText = (text) => text.toLowerCase().replace(/\s/g, '-');

TealiumTags.sendAnalytics = () => {};

TealiumTags.propTypes = {
  tags: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.node,
};

TealiumTags.defaultProps = {
  tags: {},
};

export default TealiumTags;
